import { render, staticRenderFns } from "./technician-list.vue?vue&type=template&id=994e854c&scoped=true&"
import script from "./technician-list.vue?vue&type=script&lang=js&"
export * from "./technician-list.vue?vue&type=script&lang=js&"
import style0 from "./technician-list.vue?vue&type=style&index=0&id=994e854c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994e854c",
  null
  
)

export default component.exports